import type { ReactNode } from 'react';

interface StatisticsLabelProps {
  children?: ReactNode;
  /** Additional CSS classes to apply to the label. */
  className?: string;
}

export default function StatisticsLabel({ className = '', children }: StatisticsLabelProps) {
  return (
    <span
      className={`min-w-0 wrap-break-word font-robotoRegular text-center text-[12px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark ${className}`}
    >
      {children}
    </span>
  );
}
